export const preventNonNumericInput = (
  e: React.SyntheticEvent<Element, InputEvent>
) => {
  if (e.nativeEvent.data && /\D/.test(e.nativeEvent.data)) {
    e.preventDefault();
  }
};
